import { CreateAttributeService } from './../shared/createattribute.service';

import {of as observableOf,  Observable } from 'rxjs';

import { isNullOrUndefined } from 'util';
import { ParseJsonQuestion } from '../shared/qaTicket';
import { forEach } from '@angular/router/src/utils/collection';
import { InfodialogComponent } from './../dialogs/infodialog/infodialog.component';
import { Component, OnInit, Inject } from '@angular/core';
import { NgForm } from '@angular/forms/src/directives/ng_form';
import { QuestionService } from '../shared/questionService';
import { LocalStorage } from '../shared/localstorage.service';
import { QAResponse, Question, Section } from '../shared/qaTicket';
import { MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatGridTileHeaderCssMatStyler } from '@angular/material';
import { DataSource } from '@angular/cdk/table';
import { ConditionalAttribute } from './conditionalattribute';
import { ConfirmdialogComponent } from '../dialogs/confirmdialog/confirmdialog.component';
import { ticketType } from '../shared/ticket-types.model';
import { element } from '@angular/core/src/render3';

@Component({
    templateUrl: './qaticket-config.component.html',
    styleUrls: ['./qaticket-config.component.scss']
})
export class QATicketConfigComponent implements OnInit {

    questions: Question[];
    displayedColumns = ['Section', 'Order', 'QuestionText', 'Condition', 'CanNA'];
    dataSource: QuestionDataSource;
    loading = false;
    screen = false;
    showMatTable = false;
    source: any;

    changeOrderEx = false;
    changeOrderNo = false;
    changeOrderLo = false;
    changeOrderRe = false;
    changeOrderMa = false;
    changeOrderEn = false;
    question1 = new Question();
    excavator: Question[];
    notification: Question[];
    location: Question[];
    remarks: Question[];
    map: Question[];
    end: Question[];

    allActive: Question[];
    jsonQuestions: ParseJsonQuestion[];
    constructor(
        private questionService: QuestionService,
        private localStorage: LocalStorage, public dialog: MatDialog) { }

    ngOnInit() {
        this.loading = true;

        this.questionService.getActive(this.localStorage.getItem('currentState')).then(questions => {
            questions.forEach(question => {
                if (!(question.Condition == null || question.Condition === '')) {
                    this.jsonQuestions = JSON.parse(question.Condition);
                    question.Condition = '';
                    this.jsonQuestions.forEach(element => {
                        if (element.attribute === 'ticketType') {
                            question.Condition += ' Ticket Type: ' + element.value;
                        } else if (element.attribute === 'source') {
                            question.Condition += ' Source: ' + element.value;
                        }
                    });
                }
            });
            this.questions = questions;

            this.excavator = questions.filter(x => x.Section === 0);
            this.notification = questions.filter(x => x.Section === 1);
            this.location = questions.filter(x => x.Section === 2);
            this.remarks = questions.filter(x => x.Section === 3);
            this.map = questions.filter(x => x.Section === 4);
            this.end = questions.filter(x => x.Section === 5);
            this.loading = false;
            this.dataSource = new QuestionDataSource(this.questions);
        });

    }

    DragEnter($event) {
        if (this.isbefore(this.source, $event.target)) {
            $event.target.parentNode.insertBefore(this.source, $event.target); // insert before
        } else {
            if ($event.target.nextSibling.parentNode !== this.source && $event.target.nextSibling.parentNode === this.source.parentNode) {
                $event.target.parentNode.insertBefore(this.source, $event.target.nextSibling); // insert after
            }
        }
    }

    DragStart($event) {
        this.source = $event.target;
        $event.dataTransfer.effectAllowed = 'move';
    }

    isbefore(a, b) {
        if (a.parentNode === b.parentNode) {
            for (let cur = a; cur; cur = cur.previousSibling) {
                if (cur === b) {
                    return true;
                }
            }
        }
        return false;
    }

    toggleCanOrder(id) {

        switch (id) {
            case 'orderEx':
                this.changeOrderEx = false;
                break;
            case 'orderNo':
                this.changeOrderNo = false;
                break;
            case 'orderLo':
                this.changeOrderLo = false;
                break;
            case 'orderRe':
                this.changeOrderRe = false;
                break;
            case 'orderMa':
                this.changeOrderMa = false;
                break;
            case 'orderEn':
                this.changeOrderEn = false;
                break;
        }
    }

    saveNewOrder(id) {
        this.screen = true;
        const order = new Array<number>();
        const cards = [].slice.call(document.getElementById(id).getElementsByTagName('mat-card'));
        cards.forEach(card => {
            order.push(card.getAttribute('id'));
        });
        this.questionService.updateQuestionOrder(order, this.localStorage.getItem('currentState')).then(questions => {
            const updatedQuestions: Question[] = questions;
            updatedQuestions.forEach(question => {
                if (!(question.Condition == null || question.Condition === '')) {
                    this.jsonQuestions = JSON.parse(question.Condition);
                    question.Condition = '';
                    this.jsonQuestions.forEach(element => {
                        if (element.attribute === 'ticketType') {
                            question.Condition += ' Ticket Type: ' + element.value;
                        } else if (element.attribute === 'source') {
                            question.Condition += ' Source: ' + element.value;
                        }
                    });
                }
            });
            switch (id) {
                case 'orderEx':
                    this.excavator = updatedQuestions;
                    this.changeOrderEx = false;
                    break;
                case 'orderNo':
                    this.notification = updatedQuestions;
                    this.changeOrderNo = false;
                    break;
                case 'orderLo':
                    this.location = updatedQuestions;
                    this.changeOrderLo = false;
                    break;
                case 'orderRe':
                    this.remarks = updatedQuestions;
                    this.changeOrderRe = false;
                    break;
                case 'orderMa':
                    this.map = updatedQuestions;
                    this.changeOrderMa = false;
                    break;
                case 'orderEn':
                    this.end = updatedQuestions;
                    this.changeOrderEn = false;
                    break;
            }
            this.screen = false;
        });
    }

    openDialog(section: Section): void {
        const dialogRef = this.dialog.open(AddQuestionDialogComponent, {
            width: '500px',
            data: { section: section },
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            let newQuestion = new Question();
            newQuestion = result;
            if (result !== 'Cancel') {
                this.screen = true;
                switch (newQuestion.Section) {
                    case 0:
                        if (this.excavator.length > 0) {
                            newQuestion.Order = this.excavator[this.excavator.length - 1].Order + 1;
                        } else {
                            newQuestion.Order = 1;
                        }
                        break;
                    case 1:
                        if (this.notification.length > 0) {
                            newQuestion.Order = this.notification[this.notification.length - 1].Order + 1;
                        } else {
                            newQuestion.Order = 1;
                        }
                        break;
                    case 2:
                        if (this.location.length > 0) {
                            newQuestion.Order = this.location[this.location.length - 1].Order + 1;
                        } else {
                            newQuestion.Order = 1;
                        }
                        break;
                    case 3:
                        if (this.remarks.length > 0) {
                            newQuestion.Order = this.remarks[this.remarks.length - 1].Order + 1;
                        } else {
                            newQuestion.Order = 1;
                        }
                        break;
                    case 4:
                        if (this.map.length > 0) {
                            newQuestion.Order = this.map[this.map.length - 1].Order + 1;
                        } else {
                            newQuestion.Order = 1;
                        }
                        break;
                    case 5:
                        if (this.end.length > 0) {
                            newQuestion.Order = this.end[this.end.length - 1].Order + 1;
                        } else {
                            newQuestion.Order = 1;
                        }
                        break;
                }
                this.questionService.addQuestion(newQuestion, this.localStorage.getItem('currentState')).then(questions => {
                    questions.forEach(question => {
                        if (!(question.Condition === null || question.Condition === '')) {
                            this.jsonQuestions = JSON.parse(question.Condition);
                            question.Condition = '';
                            this.jsonQuestions.forEach(element => {
                                if (element.attribute === 'ticketType') {
                                    question.Condition += ' Ticket Type: ' + element.value;
                                } else if (element.attribute === 'source') {
                                    
                                    question.Condition += ' Source: ' + element.value;
                                }
                            });

                        }
                    });
                    switch (newQuestion.Section) {
                        case 0:
                            this.excavator = questions;
                            break;
                        case 1:
                            this.notification = questions;
                            break;
                        case 2:
                            this.location = questions;
                            break;
                        case 3:
                            this.remarks = questions;
                            break;
                        case 4:
                            this.map = questions;
                            break;
                        case 5:
                            this.end = questions;
                            break;
                    }
                    this.screen = false;
                });
            }
        });
    }

    openMultiAnswerQuestionDialog(section: Section): void {
        const dialogRef = this.dialog.open(AddMultiAnswerQuestionDialogComponent, {
            width: '500px',
            data: { section: section },
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            let newQuestion = new Question();
            newQuestion = result;
            if (result !== 'Cancel') {
                this.screen = true;
                switch (newQuestion.Section) {
                    case 0:
                        if (this.excavator.length > 0) {
                            newQuestion.Order = this.excavator[this.excavator.length - 1].Order + 1;
                        } else {
                            newQuestion.Order = 1;
                        }
                        break;
                    case 1:
                        if (this.notification.length > 0) {
                            newQuestion.Order = this.notification[this.notification.length - 1].Order + 1;
                        } else {
                            newQuestion.Order = 1;
                        }
                        break;
                    case 2:
                        if (this.location.length > 0) {
                            newQuestion.Order = this.location[this.location.length - 1].Order + 1;
                        } else {
                            newQuestion.Order = 1;
                        }
                        break;
                    case 3:
                        if (this.remarks.length > 0) {
                            newQuestion.Order = this.remarks[this.remarks.length - 1].Order + 1;
                        } else {
                            newQuestion.Order = 1;
                        }
                        break;
                    case 4:
                        if (this.map.length > 0) {
                            newQuestion.Order = this.map[this.map.length - 1].Order + 1;
                        } else {
                            newQuestion.Order = 1;
                        }
                        break;
                    case 5:
                        if (this.end.length > 0) {
                            newQuestion.Order = this.end[this.end.length - 1].Order + 1;
                        } else {
                            newQuestion.Order = 1;
                        }
                        break;
                }
                this.questionService.addQuestion(newQuestion, this.localStorage.getItem('currentState')).then(questions => {
                    questions.forEach(question => {
                        if (!(question.Condition == null || question.Condition === '')) {
                            this.jsonQuestions = JSON.parse(question.Condition);
                            question.Condition = '';
                            this.jsonQuestions.forEach(element => {
                                if (element.attribute === 'ticketType') {
                                    question.Condition += ' Ticket Type: ' + element.value;
                                } else if (element.attribute === 'source') {
                                    question.Condition += ' Source: ' + element.value;
                                }
                            });
                        }
                    });
                    switch (newQuestion.Section) {
                        case 0:
                            this.excavator = questions;
                            break;
                        case 1:
                            this.notification = questions;
                            break;
                        case 2:
                            this.location = questions;
                            break;
                        case 3:
                            this.remarks = questions;
                            break;
                        case 4:
                            this.map = questions;
                            break;
                        case 5:
                            this.end = questions;
                            break;
                    }
                    this.screen = false;
                });
            }
        });
    }

    OpenConfirmDeleteDialog(id) {
        const dialogRef = this.dialog.open(ConfirmQuestionDeleteComponent, {
            width: '500px',
            data: { id: id },
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== 'Cancel') {
                this.screen = true;
                this.questionService.removeQuestion(result,this.localStorage.getItem('currentState')).then(questions => {
                    const updatedQuestions: Question[] = questions;
                    if (updatedQuestions.length > 0) {
                        const s = updatedQuestions[0].Section;
                        updatedQuestions.forEach(question => {
                            if (!(question.Condition == null || question.Condition === '')) {
                                this.jsonQuestions = JSON.parse(question.Condition);
                                question.Condition = '';
                                this.jsonQuestions.forEach(element => {
                                    if (element.attribute === 'ticketType') {
                                        question.Condition += ' Ticket Type: ' + element.value;
                                    } else if (element.attribute === 'source') {
                                        question.Condition += ' Source: ' + element.value;
                                    }
                                });
                            }
                        });
                        switch (s) {
                            case 0:
                                this.excavator = questions;
                                break;
                            case 1:
                                this.notification = questions;
                                break;
                            case 2:
                                this.location = questions;
                                break;
                            case 3:
                                this.remarks = questions;
                                break;
                            case 4:
                                this.map = questions;
                                break;
                            case 5:
                                this.end = questions;
                                break;
                        }
                    }
                    this.screen = false;
                });
            }
        });
    }
}

export class QuestionDataSource extends DataSource<Question> {
    constructor(private questions: Question[]) {
        super();
    }
    connect(): Observable<Question[]> {
        return observableOf(this.questions);
    }

    disconnect() { }
}

@Component({
    selector: 'app-add-question-dialog',
    templateUrl: 'app-add-question-dialog.html',
    styleUrls: ['./qaticket-config.component.scss']
})
export class AddQuestionDialogComponent implements OnInit {

    isConditional: boolean;
    question = new Question();
    attribute: string;
    value: string[];
    newValue: string[];
    conditionalAttributes: ConditionalAttribute[];
    selected = new ConditionalAttribute();
    newSelected = new ConditionalAttribute();
    slidervalue = -3;
    addMoreAttributes = false;
    ticketTypes: ticketType[];
    ticketSource: string[];
    ticketType: string[] = [];
    queueCategories: QueueCategory[] = [
        { value: 'Internal', viewValue: 'Internal' },
        { value: 'External', viewValue: 'External' },
        { value: 'All', viewValue: 'All' }
    ];
    CriticalResponses: QueueCategory[] = [
        { value: 'yes', viewValue: 'Yes' },
        { value: 'no', viewValue: 'No' }
    ];
    queuecategoryvalue: string = "";
    criticalResponseValue: string= "yes";
    constructor(
        public dialogRef: MatDialogRef<AddQuestionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialog: MatDialog,
        public service: CreateAttributeService,
        public localstorage: LocalStorage) { }
    ngOnInit() {
        this.isConditional = false;
        this.service.getTicketTypes(this.localstorage.getItem('token'), this.localstorage.getItem('currentState')).subscribe(res => {
            this.ticketTypes = res['ticketType'];
            this.ticketTypes.forEach(element => this.ticketType.push(element.key));
            this.service.getTicketSources(this.localstorage.getItem('currentState')).subscribe(
                res => {
                    this.ticketSource = res;
                    this.conditionalAttributes = new Array<ConditionalAttribute>(
                        {
                            Display: 'Ticket Type',
                            Value: 'ticketType',
                            AttributeValues: this.ticketType
                        },
                        {
                            Display: 'Source',
                            Value: 'source',
                            AttributeValues: this.ticketSource
                        }
                    );

                });
            });
        }

    onSubmit() {
        if (this.slidervalue === -3) {
            const sliderdialog = this.dialog.open(ConfirmdialogComponent, {
                width: '400px',
                data: {
                    title: 'Alert',
                    content: 'You have selected the default Critical Level of -3 for this question. Is this correct?'
                }
            });
            sliderdialog.afterClosed().subscribe(result => {
                if (result === 'Cancel') {
                    return;
                }
                else {
                    this.question.CriticalLevel = this.slidervalue;
                    this.question.Section = this.data.section;
                    this.question.CustomResponse = '';
                    this.question.QueueCategory = this.queuecategoryvalue;
                    this.question.ValidResponse = this.criticalResponseValue;
                    if (this.isConditional) {
                        if(!isNullOrUndefined(this.newSelected.Value)) {
                            this.question.Condition = this.question.Condition + 'attribute":"' +
                            this.newSelected.Value + ',value":["' + this.newValue + '"]}]';
                        }
                        else {
                            this.question.Condition = '[{"attribute":"' + this.selected.Value + '","value":["' + this.value + '"]}]';
                        }
                    } else {
                        this.question.Condition = '';
                    }
                    this.dialogRef.close(this.question);
                }
            });
        }
        else {
            this.question.CriticalLevel = this.slidervalue;
            this.question.Section = this.data.section;
            this.question.CustomResponse = '';
            this.question.QueueCategory = this.queuecategoryvalue;
            this.question.ValidResponse = this.criticalResponseValue;
            if (this.isConditional) {
                if(!isNullOrUndefined(this.newSelected.Value)) {
                    this.question.Condition = this.question.Condition + 'attribute":"' +
                    this.newSelected.Value + ',value":["' + this.newValue + '"]}]';
                }
                else {
                    this.question.Condition = '[{"attribute":"' + this.selected.Value + '","value":["' + this.value + '"]}]';
                }
            } else {
                this.question.Condition = '';
            }
            this.dialogRef.close(this.question);
        }
    }

    onCancelClick(): void {
        this.dialogRef.close('Cancel');
    }

    ClearCheckboxData() {
        this.selected = new ConditionalAttribute();
    }
    addConditionalAttribute() {
        this.addMoreAttributes = true;
        this.question.Condition = '[{"attribute":"' + this.selected.Value + '","value":["' + this.value + '"]}{"'
    }
}
export interface QueueCategory {
    value: string;
    viewValue: string;
}

@Component({
    selector: 'add-multianswer-question-dialog',
    templateUrl: 'add-multianswer-question-dialog.html',
    styleUrls: ['./qaticket-config.component.scss']
})

export class AddMultiAnswerQuestionDialogComponent implements OnInit {

    isConditional: boolean;
    question = new Question();
    attribute: string;
    value: string[];
    newValue: string[];
    answervalue: string = "";
    queuecategoryvalue: string = "";
    possibleAnswerValues: string[] = [];
    possibleAnswerValuesCriticalLevel: number[] = [];
    conditionalAttributes: ConditionalAttribute[];
    addMoreAttributes = false;
    selected = new ConditionalAttribute();
    newSelected = new ConditionalAttribute();
    slidervalue = -3;
    ticketTypes: ticketType[];
    ticketSource: string[];
    ticketType: string[] = [];
    queueCategories: QueueCategory[] = [
        { value: 'Internal', viewValue: 'Internal' },
        { value: 'External', viewValue: 'External' },
        { value: 'All', viewValue: 'All' }
    ];
    constructor(
        public newDialogRef: MatDialogRef<AddMultiAnswerQuestionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialog: MatDialog,
        public service: CreateAttributeService,
        public localstorage: LocalStorage) { }
    ngOnInit() {
        this.isConditional = false;
        this.service.getTicketTypes(this.localstorage.getItem('token'), this.localstorage.getItem('currentState')).subscribe(res => {
            this.ticketTypes = res['ticketType'];
            this.ticketTypes.forEach(element => this.ticketType.push(element.key));
            this.service.getTicketSources(this.localstorage.getItem('currentState')).subscribe(
                res => {
                    this.ticketSource = res;
                    this.conditionalAttributes = new Array<ConditionalAttribute>(
                        {
                            Display: 'Ticket Type',
                            Value: 'ticketType',
                            AttributeValues: this.ticketType
                        },
                        {
                            Display: 'Source',
                            Value: 'source',
                            AttributeValues: this.ticketSource
                        }
                    );

                });
            });
    }
    onSubmit() {
        if (this.possibleAnswerValues.length === 0) {
            const infodialog = this.dialog.open(InfodialogComponent, {
                width: '400px',
                data: {
                    title: 'Alert',
                    content: 'Please add atleast one answer value text to save question.'
                }
            });
            return;
        }
        else {
            if (this.question.CanNA) {
                this.possibleAnswerValues.push('na');
                this.possibleAnswerValuesCriticalLevel.push(-3);
            }
            this.question.QueueCategory = this.queuecategoryvalue;
            this.question.ValidResponse = 'multiresponses';
            this.question.CriticalLevel = -1000;
            this.question.Section = this.data.section;
            if (this.isConditional) {
                if(!isNullOrUndefined(this.newSelected.Value)) {
                    this.question.Condition = this.question.Condition + 'attribute":"' +
                    this.newSelected.Value + ',value":["' + this.newValue + '"]}]';
                }
                else {
                    this.question.Condition = '[{"attribute":"' + this.selected.Value + '","value":["' + this.value + '"]}]';
                }
            } else {
                this.question.Condition = '';
            }
            this.question.CustomResponse = '{"possibleanswers":["' + this.possibleAnswerValues + '"],"criticallevel":["' + this.possibleAnswerValuesCriticalLevel + '"]}';
            this.newDialogRef.close(this.question);
        }
    }

    onCancelClick(): void {
        this.newDialogRef.close('Cancel');
    }

    ClearCheckboxData() {
        this.selected = new ConditionalAttribute();
    }

    AddAnswerValue() {

        const answerdialog = this.dialog.open(AddAnswerDialogComponent, {
            width: '500px',
            disableClose: true
        });

        answerdialog.afterClosed().subscribe(result => {
            if (result !== 'Cancel') {
                this.possibleAnswerValues.push(result.answervalue);
                this.possibleAnswerValuesCriticalLevel.push(result.slidervalue);
            }
        });
    }
    addConditionalAttribute() {
        this.addMoreAttributes = true;
        this.question.Condition = '[{"attribute":"' + this.selected.Value + '","value":["' + this.value + '"]}{"'
    }
}

@Component({
    selector: 'app-remove-question-dialog',
    templateUrl: 'app-remove-question-dialog.html',
    styleUrls: ['./qaticket-config.component.scss']
})
export class ConfirmQuestionDeleteComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<ConfirmQuestionDeleteComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) { }
    ngOnInit() {

    }
    onSubmit() {
        this.dialogRef.close(this.data.id);
    }

    onCancelClick(): void {
        this.dialogRef.close('Cancel');
    }
}

@Component({
    selector: 'app-add-answer-dialog',
    templateUrl: 'add-answer-dialog.html',
    styleUrls: ['./qaticket-config.component.scss']
})
export class AddAnswerDialogComponent implements OnInit {

    answervalue: string = "";
    slidervalue: number = -3;

    constructor(
        public dialogRef: MatDialogRef<AddAnswerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialog: MatDialog) { }
    ngOnInit() {

    }
    OnAddConfirm() {
        if (this.answervalue === '' || this.answervalue === null) {
            const infodialog = this.dialog.open(InfodialogComponent, {
                width: '400px',
                data: {
                    title: 'Alert',
                    content: 'Please provide answer value.'
                }
            });
            return;
        }
        else {
            if (this.slidervalue === -3) {
                const sliderdialog = this.dialog.open(ConfirmdialogComponent, {
                    width: '400px',
                    data: {
                        title: 'Alert',
                        content: 'You have selected the default Critical Level of -3 for ths answer. Is this correct?'
                    }
                });
                sliderdialog.afterClosed().subscribe(result => {
                    if (result === 'Cancel') {
                        return;
                    }
                    else {
                        this.dialogRef.close({ answervalue: this.answervalue, slidervalue: this.slidervalue });
                    }
                });
            }
            else {
                this.dialogRef.close({ answervalue: this.answervalue, slidervalue: this.slidervalue });
            }

        }
    }

    OnCloseCancel(): void {
        this.dialogRef.close('Cancel');
    }
}
